import type { FC } from 'react';
import { useEffect } from 'react';
import type { DepositFormValues, FormState } from '@mwl/core-lib';
import { useDeposit, useSubmitDepositForm } from '@mwl/core-lib';
import { Loader } from '@/components/Loader/Loader';
import styles from './DepositAutoSubmitForm.module.scss';
const formState = ({} as FormState<DepositFormValues>);
export const DepositAutoSubmitForm: FC = () => {
  const {
    payment
  } = useDeposit();
  const {
    state,
    onSubmitConfirm
  } = useSubmitDepositForm({
    formState,
    identity: payment?.identity ?? ''
  });
  useEffect(() => {
    onSubmitConfirm(({} as DepositFormValues));
  }, [onSubmitConfirm]);
  return <div data-sentry-component="DepositAutoSubmitForm" data-sentry-source-file="DepositAutoSubmitForm.tsx">
      {state.isLoading && <div className={styles.loader}>
          <Loader />
        </div>}
    </div>;
};